import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem("it_token") || null);

  useEffect(() => {
    const storedToken = localStorage.getItem("it_token");
    if (storedToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
      axios
        .get(`${API}/auth/me`)
        .then((res) => setUser(res.data))
        .catch(() => {
          localStorage.removeItem("it_token");
          delete axios.defaults.headers.common["Authorization"];
          setToken(null);
          setUser(false);
        })
        .finally(() => setLoading(false));
    } else {
      setUser(false);
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    const { token: newToken, ...userData } = res.data;
    localStorage.setItem("it_token", newToken);
    axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem("it_token");
    delete axios.defaults.headers.common["Authorization"];
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { API };
